import { Component, OnInit, ViewEncapsulation, Input } from "@angular/core";
import { IBreadcrumb } from "src/app/interfaces/breadcrumb";
import {
  ActivatedRoute,
  NavigationEnd,
  PRIMARY_OUTLET,
  Router
} from "@angular/router";
import { filter } from "rxjs/operators";
import { BreadcrumbsService } from "src/app/services/common/breadcrumbs.service";
import { Location } from "@angular/common";
import { Title } from "@angular/platform-browser";
import { TranslateService } from "@ngstack/translate";
import { environment } from "src/environments/environment";
import { MatDialog } from "@angular/material";
import { RouteGuideComponent } from "../route-guide/route-guide.component";

@Component({
  selector: "breadcrumb",
  templateUrl: "./breadcrumb.component.html",
  styles: [
    `
      .fluid-bread {
        background-color: white;
      }
      .breadcrumb {
        background-color: white;
        padding: 4px;
        margin-bottom: 0;
      }
    `
  ],
  encapsulation: ViewEncapsulation.None
})
export class BreadcrumbComponent implements OnInit {
  private ROUTE_DATA_BREADCRUMB: string = "breadcrumb";
  private ROUTE_PARAM_BREADCRUMB: string = "breadcrumb";
  private PREFIX_BREADCRUMB: string = "prefixBreadcrumb";

  // The breadcrumbs of the current route
  private currentBreadcrumbs: IBreadcrumb[];
  // All the breadcrumbs
  public breadcrumbs: IBreadcrumb[];

  @Input()
  public allowBootstrap: boolean;

  @Input()
  public addClass: string;

  public constructor(
    private breadcrumbService: BreadcrumbsService,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    public translate: TranslateService,
    private router: Router,
    private location: Location,
    private dialog: MatDialog
  ) {
    breadcrumbService.get().subscribe((breadcrumbs: IBreadcrumb[]) => {
      this.breadcrumbs = breadcrumbs as IBreadcrumb[];
    });
  }

  public hasParams(breadcrumb: IBreadcrumb) {
    return Object.keys(breadcrumb.params).length
      ? ["/management" + breadcrumb.url, breadcrumb.params]
      : ["/management" + breadcrumb.url];
  }

  

  public ngOnInit() {
    
    if (this.router.navigated) {
      this.generateBreadcrumbTrail();
    }

    // subscribe to the NavigationEnd event
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.generateBreadcrumbTrail();
      });
  }

  public back() {
    if (this.router.navigated)
      this.location.back();
  }

  private generateBreadcrumbTrail() {
    // reset currentBreadcrumbs
    this.currentBreadcrumbs = [];

    // get the root of the current route
    let currentRoute: ActivatedRoute = this.activatedRoute.root;

    // set the url to an empty string
    let url: string = "";

    // iterate from activated route to children
    while (currentRoute.children.length > 0) {
      let childrenRoutes: ActivatedRoute[] = currentRoute.children;
      let breadCrumbLabel: string = "";

      // iterate over each children
      childrenRoutes.forEach(route => {
        // Set currentRoute to this route
        currentRoute = route;
        // Verify this is the primary route
        if (route.outlet !== PRIMARY_OUTLET) {
          return;
        }
        const hasData = route.routeConfig && route.routeConfig.data;
        const hasDynamicBreadcrumb: boolean = route.snapshot.params.hasOwnProperty(
          this.ROUTE_PARAM_BREADCRUMB
        );

        if (hasData || hasDynamicBreadcrumb) {
          /*
          Verify the custom data property "breadcrumb"
          is specified on the route or in its parameters.
          Route parameters take precedence over route data
          attributes.
          */
          if (hasDynamicBreadcrumb) {
            breadCrumbLabel = route.snapshot.params[
              this.ROUTE_PARAM_BREADCRUMB
            ].replace(/_/g, " ");
          } else if (
            route.snapshot.data.hasOwnProperty(this.ROUTE_DATA_BREADCRUMB)
          ) {
            breadCrumbLabel = route.snapshot.data[this.ROUTE_DATA_BREADCRUMB];
          }
          // Get the route's URL segment
          let routeURL: string = route.snapshot.url
            .map(segment => segment.path)
            .join("/");
          url += `/${routeURL}`;
          // Cannot have parameters on a root route
          if (routeURL.length === 0) {
            route.snapshot.params = {};
          }
          // Add breadcrumb
          let breadcrumb: IBreadcrumb = {
            label: breadCrumbLabel,
            params: route.snapshot.params,
            url: url,
            hasGuide: route.snapshot.data['hasGuide'] != undefined ? route.snapshot.data['hasGuide'] : true,
          };

          // Add the breadcrumb as 'prefixed'. It will appear before all breadcrumbs
          if (route.snapshot.data.hasOwnProperty(this.PREFIX_BREADCRUMB)) {
            this.breadcrumbService.storePrefixed(breadcrumb);
          } else {
            this.currentBreadcrumbs.push(breadcrumb);
          }

          this.setTitle(this.translate.get("label." + breadcrumb.label))

        }
      });
      this.breadcrumbService.store(this.currentBreadcrumbs);
    }
  }

  haveGuideRoute(): boolean 
  {
    for(var i = 0; i < this.breadcrumbs.length; i++) {
      if(this.breadcrumbs[i].hasGuide === false)
      return false;
    }


    return true;
  }

  public setTitle(newTitle: string) {
    var mainTitle = environment.siteTitle
    if (newTitle)
      newTitle = 'گنبد دانش' + ' / ' + newTitle
    else
      newTitle = mainTitle
    this.titleService.setTitle(newTitle);
  }


  getCurrentParamLessRoute(): string 
  {
    let urlWithNoParam = '';
    const urlSegments = this.router.url.split('/');
    urlSegments.splice(0,1);
    let snapshot = this.activatedRoute.snapshot;

    for(var i = 0; i < urlSegments.length; i++)
    {
      if(snapshot == undefined || snapshot.routeConfig == undefined)
        break;
      
      const segment = urlSegments[i];
      const currentPath = snapshot.routeConfig.path;
      
      if(segment == currentPath)
      {
        urlWithNoParam += segment + '/';
      }else{
        if(currentPath.indexOf(':') != -1)
        {
          urlWithNoParam += currentPath.split(':')[0];
        }
      }
      snapshot = snapshot.children[0];
    }

    return urlWithNoParam;
  }

  onGuideOpen()
  {
    const currentRoute = this.getCurrentParamLessRoute();

    this.dialog.open(RouteGuideComponent, {
      width: '80%',
      data: {
        url: currentRoute,
      }
    });
  }
}
